import { TableSearch } from "ui/components/Table/TableSearch";
import { memo } from "react";
import { initialDataWithPagination } from "services/api/consts";
import {
  CALCULATION_SEARCH_COLUMNS,

} from "./consts";
import { CalculationSearchResultsProps } from "./types";
import { useTranslate } from "helpers";

const CalculationSearchResults: React.FC<CalculationSearchResultsProps> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
  } = props;

  const { t } = useTranslate();

  return (
    <>
      <TableSearch
        columns={CALCULATION_SEARCH_COLUMNS(t)}
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={false}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
      />
    </>
  );
};
export default memo(CalculationSearchResults);
